import ButtonIcon from "@mui/icons-material/Add"
import { Button } from "@mui/material"
import React from "react"
import { ButtonProps, Link, useRecordContext } from "react-admin"

export const AddBillingRecipientProfileButton: React.FC<ButtonProps> = (props) => {
  const record = useRecordContext(props)

  return (
    <Button
      color="primary"
      component={Link}
      to={{
        pathname: "/billing_recipient_profiles/create",
      }}
      state={{ record: { customer_id: record.id } }}
    >
      <ButtonIcon /> Create Billing Recipient Profile
    </Button>
  )
}
